import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Label, Tooltip } from 'recharts';

import { encryptStorage } from '../constant';

/**
 * PC_Ac_04 getAttritionData gets imported from api.js file
 */
import { getAttritionData, getDomainData } from '../service/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../components/css/Dashboard-styles.css';

export default function AttritionData(props) {
    /**
     * PC_Ac_02
     * The data state , resignedData , abscondedData , terminatedData, year , role , domains , filterPressed , filterValue , filterShow , filterData variable is created for storing the response data
     */
    const [data, setData] = useState({});

    const [resignedData, setResignedData] = useState({});

    const [abscondedData, setAbscondedData] = useState({});

    const [terminatedData, setTerminatedData] = useState({});

    const [year, setYear] = useState();

    const [role, setRole] = useState('');

    const [domains, setDomains] = useState([]);

    const [filterPressed, setFilterPressed] = useState(false);

    const [filterValue, setFilterValue] = useState('');

    const [filterShow, setFilterShow] = useState(false);

    // const [year, setYear] = useState();

    const filterObj = {
        domain: '',
        year: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    /**
     * PC_Ac_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        setRole(props.role);

        fetchApi();
    }, []);

    /**
     * PC_Ac_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getAttritionData() function with respective parameters
     */

    const fetchApi = async (dataFilter = '') => {
        let resp;

        //

        if (dataFilter.domain || dataFilter.year) {
            resp = await getAttritionData(dataFilter, props.role);
        } else {
            resp = await getAttritionData('', props.role);
        }

        if (resp?.data?.ResponseData) {
            setData(resp.data.ResponseData);

            setResignedData(resp.data.ResponseData.attritionObj.resigned);

            setAbscondedData(resp.data.ResponseData.attritionObj.abscond);

            setTerminatedData(resp.data.ResponseData.attritionObj.termination);

            setYear(resp.data.ResponseData.Year);
        }

        const domainDrop = await getDomainData();

        if (domainDrop?.data?.ResponseData.length) setDomains(domainDrop.data.ResponseData);
    };

    const filterClicked = () => {
        fetchApi(filterData);

        setFilterPressed(true);
    };

    const graphData = (resign, absconde, terminate) => {
        return [
            {
                Name: `Q1, ${year}`,
                Resigned: resign.Q1,
                Absconded: absconde.Q1,
                Terminated: terminate.Q1,
            },
            {
                Name: `Q2, ${year}`,
                Resigned: resign.Q2,
                Absconded: absconde.Q2,
                Terminated: terminate.Q2,
            },
            {
                Name: `Q3, ${year}`,
                Resigned: resign.Q3,
                Absconded: absconde.Q3,
                Terminated: terminate.Q3,
            },
            {
                Name: `Q4, ${year}`,
                Resigned: resign.Q4,
                Absconded: absconde.Q4,
                Terminated: terminate.Q4,
            },
        ];
    };

    /**
     * PC_Ac_10
     * The response resignedData , abscondedData , terminatedData gets stored in the data variable and passed to the LineChart
     */

    return (
        <>
            <div className="d-flex justify-content-between">
                <h1 className="tt-bold font-15 p-3">Attrition Rate</h1>
                <div className="dropdown m-2 ">
                    <button
                        className={`btn ${role == 'Hr Manager' ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
                        type="button"
                        // id="dropdownMenuButton123"
                        // data-bs-toggle="dropdown"
                        // aria-expanded="false"

                        onClick={() => {
                            setFilterShow(!filterShow);
                        }}
                    >
                        {filterData.domain && filterPressed && filterData.domain != filterValue
                            ? `${filterValue}`
                            : filterData.domain && filterPressed
                                ? `${filterData.domain}`
                                : role == 'Hr Manager'
                                    ? `ALL`
                                    : null}
                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                    </button>

                    {filterShow ? (
                        <div
                            className="dropdown-menu dashboard-filter-dropdown px-3 py-3"
                            style={{ display: 'block' }}
                            onBlur={(event) => {
                                if (!event.currentTarget.contains(event.relatedTarget)) {
                                    setFilterShow(false);
                                }
                            }}
                        >
                            <div className="d-flex justify-content-between">
                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                <button
                                    className="btn p-0"
                                    onClick={() => {
                                        setFilterShow(!filterShow);
                                    }}
                                >
                                    <img src="/Images/Path 38820.svg" />
                                </button>
                            </div>
                            {role == 'Hr Manager' ? (
                                <>
                                    <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                    <select
                                        value={filterData.domain}
                                        onChange={(e) => {
                                            setFilterData((filterData) => ({
                                                ...filterData,
                                                [e.target.name]: e.target.value,
                                            }));
                                        }}
                                        className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                        name="domain"
                                    >
                                        <option selected value="">
                                            Select
                                        </option>
                                        {domains.map((domain) => {
                                            return <option value={domain}>{domain}</option>;
                                        })}
                                    </select>
                                </>
                            ) : null}
                            {/* <div className="d-flex justify-content-between">
              <h5 className="font-12 bold-text mt-3">Date Range</h5>
            </div> */}
                            <label className="medium-text font-12 d-flex mb-1">Year</label>
                            <DatePicker
                                selected={filterData.year}
                                onChange={(e) => {
                                    setFilterData((filterData) => ({
                                        ...filterData,

                                        ['year']: e,
                                    }));
                                }}
                                name="year"
                                showYearPicker
                                value={filterData.year}
                                className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                dateFormat="yyyy"
                                placeholderText="Select Year"
                            />
                            {/* <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" /> */}
                            <div className="d-flex justify-content-end mt-3">
                                <button
                                    onClick={() => {
                                        setFilterData(filterObj);
                                        fetchApi();
                                        setFilterPressed(false);
                                        setFilterShow(!filterShow);
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                >
                                    Clear
                                </button>
                                <button
                                    autoFocus
                                    onClick={(e) => {
                                        filterClicked(e);
                                        setFilterValue(filterData.domain);
                                        setFilterShow(!filterShow);
                                    }}
                                    type="button"
                                    className="btn hive-btn-primary dashboard-btn-filter"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>

            <div className>
                <div className="d-flex ps-3">
                    <div className="col-md-6 me-4">
                        <p className="font-11 semibold-text mb-1">Total Team Members</p>
                        <label className="font-31 tt-bold custom-attrition-color">{data.totalEmp2}</label>
                    </div>
                    <div className="col-md-4">
                        <p className="font-11 semibold-text mb-1">Attrition Rate</p>
                        <label className="font-31 tt-bold custom-attrition-color-2">{data.totalAttritionRate}%</label>
                    </div>
                </div>
                <div className="col-md-12 mt-2">
                    <div className="float-end">
                        <label className="regular-text font-10 me-4">
                            <span className="dashboard-attrition-legrand-1 me-2" />
                            Resigned
                        </label>
                        <label className="regular-text font-10 me-4">
                            <span className="dashboard-attrition-legrand-2 me-2" />
                            Absconded
                        </label>
                        <label className="regular-text font-10 me-4">
                            <span className="dashboard-attrition-legrand-3 me-2" />
                            Terminated
                        </label>
                    </div>
                    <div className="position-relative">
                        <span className="attrition-yaxis-style">No of employee</span>
                        <span className="attrition-xaxis-style">Time Period</span>
                        <LineChart
                            width={390}
                            height={171}
                            padding={{ top: 30 }}
                            data={graphData(resignedData, abscondedData, terminatedData)}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="Name"
                                padding={{ left: 30, right: 30 }}
                                style={{
                                    fontSize: '8px',
                                    fontFamily: 'SF Pro Regular',
                                    color: '#959595',
                                }}
                                textAnchor="middle"
                                sclaeToFit="true"
                                verticalAnchor="end"
                                interval={0}
                            >
                                {/* <Label value="Evaluation Period" offset={0} position="insideBottom" style={{
                fontSize: '12px',
                fontFamily: 'SF Pro Regular',
                color: "#959595"
              }} /> */}
                            </XAxis>
                            <YAxis
                                style={{
                                    fontSize: '9px',
                                    fontFamily: 'SF Pro Regular',
                                    color: '#959595',
                                }}
                            >
                                {/* <Label value='percentage' offset={5} angle="-90" position='insideLeft' style={{
                fontSize: '10px',
                fontFamily: 'SF Pro Regular',
                color: "#959595"
              }} /> */}
                            </YAxis>
                            {/* <Legend /> */}
                            <Line dataKey="Resigned" rating-yaxis-style stroke="#898989" activeDot={{ r: 8 }} />
                            <Line dataKey="Absconded" stroke="#ff3a5b" activeDot={{ r: 8 }} />
                            <Line dataKey="Terminated" stroke="#d9649c" activeDot={{ r: 8 }} />
                            <Tooltip />
                        </LineChart>
                    </div>
                </div>
            </div>
        </>
    );
}
